import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { NotificationTemplateModel, ParameterModel } from '../../../store/notification-template/model';

export abstract class AbstractNotificationTemplateApiService {
  public abstract getAllNotificationTemplates(): Observable<InteractorResponse<NotificationTemplateModel[]>>;
  public abstract getNotificationTemplateById(id: number): Observable<InteractorResponse<NotificationTemplateModel>>;
  public abstract saveNotificationTemplate(template: NotificationTemplateModel): Observable<InteractorResponse<NotificationTemplateModel>>;
  public abstract getParameters(): Observable<InteractorResponse<ParameterModel[]>>;
}
